export * from './extract-survey-answers-adapter';
